/* eslint-disable max-len */
import subModuleKeys from '@/modules/constants/subModuleKeys';

const UserSettingsModule = () => import(/* webpackChunkName: "usersettings" */ '@/components/modules/settings/users/UserSettingsModule.vue');
const UserSettingsList = () => import(/* webpackChunkName: "usersettingslist" */ '@/components/modules/settings/users/list/UserSettingsList.vue');
const UserSettingsEdit = () => import(/* webpackChunkName: "usersettingsedit" */ '@/components/modules/settings/users/list/edit/UserSettingsEdit.vue');
const UserSettingsEditContactInfo = () => import(/* webpackChunkName: "usersettingseditcontact" */ '@/components/modules/settings/users/list/edit/tabs/contact/UserSettingsEditContactInfo');
const UserSettingsEditAuthority = () => import(/* webpackChunkName: "usersettingseditauthority" */ '@/components/modules/settings/users/list/edit/tabs/auth/UserSettingsEditAuthority');
const MySettingsModule = () => import(/* webpackChunkName: "mysettings" */ '@/components/modules/settings/MySettingsModule.vue');
const EconomySettingsV2Module = () => import(/* webpackChunkName: "economysettingsv2" */ '@/components/modules/economy/settings/EconomySettingsModule');
const OrganizerSettingsModule = () => import(/* webpackChunkName: "organizersettings" */ '@/components/modules/settings/organizer/OrganizerSettingsModule.vue');
const ManageUsersModule = () => import(/* webpackChunkName: "manageusers" */ '@/components/modules/settings/users/UserSettingsModule.vue');

const subModules = {
  // TODO: Once we're in Vue 3 and have Vue-router 4, we should dynamically build all private routes.
  // That way we won't need these stupid "_pro" etc. suffixes for the economy settings routes.
  [subModuleKeys.ECONOMY_SETTINGS_PRO]: {
    name: subModuleKeys.ECONOMY_SETTINGS_PRO,
    component: EconomySettingsV2Module,
    path: '/economy/settings_pro',
    props: {
      moduleKey: subModuleKeys.ECONOMY_SETTINGS_PRO,
      variant: 'large',
    },
  },
  [subModuleKeys.ECONOMY_SETTINGS_MEDIUM]: {
    name: subModuleKeys.ECONOMY_SETTINGS_MEDIUM,
    component: EconomySettingsV2Module,
    path: '/economy/settings_medium',
    props: {
      moduleKey: subModuleKeys.ECONOMY_SETTINGS_MEDIUM,
      variant: 'medium',
    },
  },
  [subModuleKeys.ECONOMY_SETTINGS_LIGHT]: {
    name: subModuleKeys.ECONOMY_SETTINGS_LIGHT,
    component: EconomySettingsV2Module,
    path: '/economy/settings_light',
    props: {
      moduleKey: subModuleKeys.ECONOMY_SETTINGS_LIGHT,
      variant: 'light',
    },
  },
  [subModuleKeys.ORGANIZER_SETTINGS]: {
    name: subModuleKeys.ORGANIZER_SETTINGS,
    component: OrganizerSettingsModule,
    path: '/settings/organizer',
    props: { moduleKey: subModuleKeys.ORGANIZER_SETTINGS },
  },
  [subModuleKeys.USER_SETTINGS]: {
    component: UserSettingsModule,
    path: '/settings/users',
    props: { moduleKey: subModuleKeys.USER_SETTINGS },
    children: [
      {
        path: '',
        name: subModuleKeys.USER_SETTINGS,
        props: { moduleKey: subModuleKeys.USER_SETTINGS },
        component: UserSettingsList,
      },
      {
        path: 'edit/:userId?',
        alias: 'new',
        name: subModuleKeys.USER_SETTINGS_EDIT,
        component: UserSettingsEdit,
        props: (route) => ({
          userId: Number.parseInt(route.params.userId, 10) || null,
          moduleKey: subModuleKeys.USER_SETTINGS,
        }),
        children: [
          {
            path: 'basic',
            name: subModuleKeys.USER_SETTINGS_EDIT_CONTACT,
            props: { moduleKey: subModuleKeys.USER_SETTINGS },
            component: UserSettingsEditContactInfo,
          },
          {
            path: 'authority',
            props: { moduleKey: subModuleKeys.USER_SETTINGS },
            component: UserSettingsEditAuthority,
            name: subModuleKeys.USER_SETTINGS_EDIT_AUTH,
          },
        ],
      },
    ],
  },
  [subModuleKeys.MY_SETTINGS]: {
    name: subModuleKeys.MY_SETTINGS,
    component: MySettingsModule,
    path: '/settings/user',
    props: { moduleKey: subModuleKeys.MY_SETTINGS },
  },
  [subModuleKeys.MANAGE_USERS]: {
    name: subModuleKeys.MANAGE_USERS,
    component: ManageUsersModule,
    path: '/settings/userz',
    props: { moduleKey: subModuleKeys.MANAGE_USERS },
  },
};

export default subModules;
